import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './design-system/styles/base.css'

// Filter out React Router development warnings
const originalWarn = console.warn
console.warn = (...args) => {
  const message = args[0]
  if (
    typeof message === 'string' && (
      message.includes('React Router Future Flag Warning') ||
      message.includes('startTransition') ||
      message.includes('relativeSplatPath')
    )
  ) {
    return // Suppress these specific warnings
  }
  originalWarn.apply(console, args)
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)